// src/pages/Dashboard/Restaurants.jsx
import React, { useState, useEffect } from 'react';
import RestaurantTable from '../../components/Layout/Dashboard/Restaurant/Restaurant';

const Restaurants = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    setIsDark(localStorage.getItem('theme') === 'dark');
  }, []);

  return <RestaurantTable isDark={isDark} />;
};

export default Restaurants;